/*==============================================================
FILTER GALLERY BY COLOR
==============================================================*/

function wwFilterGallery(color) {

    color = String(color).trim().toLowerCase().replace(/\s+/g, '-');

    const gallery = document.querySelector('.ww-gallery');

    if (!gallery) return;

    const slides = gallery.querySelectorAll('.ww-gallery__slide');
    const thumbs = gallery.querySelectorAll('.ww-thumb');

    let firstVisibleSlide = null;
    let firstVisibleThumb = null;

    slides.forEach(slide => {

        const slideColor = slide.dataset.color;

        if (slideColor === color) {

            slide.style.display = '';

            if (!firstVisibleSlide)
                firstVisibleSlide = slide;

        } else {

            slide.style.display = 'none';

        }

    });

    thumbs.forEach(thumb => {

        const thumbColor = thumb.dataset.color;

        if (thumbColor === color) {

            thumb.style.display = '';

            if (!firstVisibleThumb)
                firstVisibleThumb = thumb;

        } else {

            thumb.style.display = 'none';

            thumb.classList.remove('is-active');

        }

    });

    if (!firstVisibleSlide) return;

    slides.forEach(slide => slide.classList.remove('is-active'));

    thumbs.forEach(thumb => thumb.classList.remove('is-active'));

    firstVisibleSlide.classList.add('is-active');

    if (firstVisibleThumb)
        firstVisibleThumb.classList.add('is-active');

}
document.addEventListener("DOMContentLoaded", () => {
    const mediaDatabase = JSON.parse(
    document.getElementById("ww-media-database").textContent
);

console.log(mediaDatabase);

    const wwGroups = document.querySelectorAll(".ww-option-values");

    if (!wwGroups.length) return;

    wwGroups.forEach((group, optionIndex) => {

        group.addEventListener("click", (event) => {

            const button = event.target.closest(".ww-option-button");
            if (!button) return;

            // Update WW active state
            group.querySelectorAll(".ww-option-button").forEach(btn => {
                btn.classList.remove("active");
            });

            button.classList.add("active");

            const value = button.dataset.value;
            /*----------------------------------------
Detect Color option
----------------------------------------*/

const optionName = (
    group
        .closest(".ww-option")
        ?.querySelector(".ww-option-name")
        ?.textContent || ""
)
.trim()
.toLowerCase();

if (optionName === "color") {

    wwFilterGallery(value);

    document.dispatchEvent(new CustomEvent("ww:variant:changed", {
        detail: {
            color: value
        }
    }));
}

            // Find matching Dawn input
            const dawnFieldsets = document.querySelectorAll("variant-selects fieldset");

            if (!dawnFieldsets[optionIndex]) return;

            const dawnInput = dawnFieldsets[optionIndex].querySelector(
                `input[value="${CSS.escape(value)}"]`
            );

            if (!dawnInput) return;

            dawnInput.checked = true;

            dawnInput.dispatchEvent(
                new Event("change", {
                    bubbles: true
                })
            );

        });

    });

    // Keep WW picker synced when Shopify changes variant
    document.addEventListener("change", (event) => {

        const input = event.target;

        if (
            !input.matches("variant-selects input[type='radio']")
        ) return;

        const dawnFieldsets = [...document.querySelectorAll("variant-selects fieldset")];

        const optionIndex = dawnFieldsets.findIndex(fieldset =>
            fieldset.contains(input)
        );

        if (optionIndex === -1) return;

        const wwGroup = wwGroups[optionIndex];

        if (!wwGroup) return;

        wwGroup.querySelectorAll(".ww-option-button").forEach(btn => {
            btn.classList.remove("active");
        });

        const wwButton = wwGroup.querySelector(
            `.ww-option-button[data-value="${CSS.escape(input.value)}"]`
        );

        if (wwButton) {
            wwButton.classList.add("active");
        }
        const optionName = (
    wwGroup.closest(".ww-option")
        ?.querySelector(".ww-option-name")
        ?.textContent || ""
).trim().toLowerCase();

if (window.wwGallery && window.wwGallery.filterByVariant) {

   const color =
document.querySelector('.ww-option:nth-of-type(1) .ww-option-button.active')?.dataset.value;

const fit =
document.querySelector('.ww-option:nth-of-type(2) .ww-option-button.active')?.dataset.value;

const size =
document.querySelector('.ww-option:nth-of-type(3) .ww-option-button.active')?.dataset.value;

const variant = window.wwGallery.variants.find(v =>
    v.option1 === color &&
    v.option2 === fit &&
    v.option3 === size
);

if (variant) {
    window.wwGallery.filterByVariant(variant.featured_media);
}

}

    });

});
/* =====================================================
   SIZE GUIDE MODAL
===================================================== */

document.addEventListener("DOMContentLoaded", () => {

    const openBtn = document.getElementById("wwSizeGuideBtn");
    const modal = document.getElementById("wwSizeGuideModal");

    if (!openBtn || !modal) return;

    const closeBtn = document.getElementById("wwCloseSizeGuide");
    const overlay = modal.querySelector(".ww-size-modal-overlay");

    function openModal() {
        modal.classList.add("active");
        document.body.classList.add("ww-modal-open");
    }

    function closeModal() {
        modal.classList.remove("active");
        document.body.classList.remove("ww-modal-open");
    }

    openBtn.addEventListener("click", function(e) {
        e.preventDefault();
        openModal();
    });

    if (closeBtn) {
        closeBtn.addEventListener("click", closeModal);
    }

    if (overlay) {
        overlay.addEventListener("click", closeModal);
    }

    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape") {
            closeModal();
        }
    });

});
/* =====================================================
   SIZE GUIDE
===================================================== */

document.addEventListener("DOMContentLoaded",()=>{

    const openBtn=document.getElementById("wwSizeGuideBtn");
    const modal=document.getElementById("wwSizeGuideModal");

    if(!openBtn || !modal){
        return;
    }

    const closeBtn=document.getElementById("wwCloseSizeGuide");
    const overlay=modal.querySelector(".ww-size-modal-overlay");

    function closeModal(){

        modal.classList.remove("active");

        document.body.classList.remove("ww-modal-open");

    }

    function openModal(){

        modal.classList.add("active");

        document.body.classList.add("ww-modal-open");

    }

    openBtn.addEventListener("click",(e)=>{

        e.preventDefault();

        openModal();

    });

    closeBtn.addEventListener("click",closeModal);

    overlay.addEventListener("click",closeModal);

    document.addEventListener("keydown",(e)=>{

        if(e.key==="Escape"){

            closeModal();

        }

    });

});